<template>
  <div class="PeopleDetail row">
    <div class="d-flex col-12 col-md-6">
      <people-card
        class="flex-grow-1 d-flex flex-column"
        :image="{src: image.src, alt: image.alt}"
        text-container-class="flex-grow-1 d-flex flex-column"
      >
        <span slot="name" class="name text text-24 uppercase text-extra-bold text-color-grey ">
          <slot name="name"></slot>
        </span>
        <span slot="role" class="role text text-20 uppercase text-color-grey">
          <slot name="role"></slot>
        </span>
        <span slot="city" class="city text text-20 uppercase text-color-grey">
          <slot name="city"></slot>
        </span>
      </people-card>
    </div>
    <div class="d-flex col-12 col-md-6 pt-6 pt-md-0">
      <title-text class="text-align-left">
        <p slot="text" class="text text-20 text-light">
          <slot name="text"></slot>
        </p>
      </title-text>
    </div>
  </div>
</template>

<script>
  import PeopleCard from '@components/people-card';
  import TitleText from '@components/title-text';

  export default {
    name: 'PeopleDetail',
    components: {TitleText, PeopleCard},
    props: {
      image: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "~$scss/variables";

  .PeopleDetail {
    @media (min-width: $bootstrap-md) {
      ::v-deep .image {
        max-width: 500px;
      }
    }
  }
</style>
